import React from 'react'

export default function Footer(props) {
  return (
    <footer>
      <div className="dashboard-footer">
        <p className="dashboard-footer__link">
          <a
            href="https://support.spacemarket.com/ja/articles/74f65e5e"
            target="_blank"
          >
            {i18n.t('page.shared.l_00009')}
          </a>
          <span className="dashboard-footer__link-separator">|</span>
          <a href="https://support.spacemarket.com/ja" target="_blank">
            {i18n.t('page.shared.l_00010')}
          </a>
        </p>
        <p className="dashboard-footer__copyright">
          <small>{i18n.t('page.shared.l_00014')}</small>
        </p>
      </div>
    </footer>
  )
}
